class MobileSearch extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    this.listeners.add(
      this.els.open.element,
      'click',
      this.toggleSearch.bind(this, true),
    )
    this.listeners.add(
      this.els.close.element,
      'click',
      this.toggleSearch.bind(this, false),
    )
  }

  toggleSearch (isOpen) {
    this.els.open.element.ariaHidden = isOpen ? 'true' : 'false'
    this.els.close.element.ariaHidden = isOpen ? 'false' : 'true'
    this.els.search.element.ariaHidden = isOpen ? 'false' : 'true'

    if (isOpen) {
      const searchInput = this.externalEls?.input.element

      // iOS fix?
      setTimeout(() => {
        searchInput.focus()
        searchInput.click()
      }, 50)
    }
  }
}

if (!customElements.get('mobile-search')) {
  customElements.define('mobile-search', MobileSearch)
}
